<template>
  <div class="position-relative" id="examResultSingle">
    <neo-print-wrapper title="Exam Report">
      <a-spin :spinning="loading">
        <div class="row">
          <div class="col-12">
            <h4>{{ classStudent.first_name }} {{ classStudent.last_name }}</h4>
            <p class="mb-2">
              Student code: <span class="font-weight-bold">{{ studentData.student_code }}</span> | Class: <span class="font-weight-bold">{{ examData.school_class.name }}</span> | Section: <span class="font-weight-bold">{{ examData.section.name }}</span> | Roll No: <span class="font-weight-bold">{{ studentData.roll_no }}</span>
            </p>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <vue-custom-scrollbar class="scroll-area">
              <table class="table table-sm table-sm-responsive table-bordered">
                <thead>
                  <tr>
                    <th scope="col">Subject</th>
                    <th scope="col">Score</th>
                    <th v-if="examData.grades">Grade</th>
                    <th scope="col">Pass Mark</th>
                    <th scope="col">Full Mark</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="examSubject in examData.class_section_exam_subject"
                    :key="examSubject.id"
                  >
                    <th scope="row">
                      {{ examSubject.subject.name }} ({{ examSubject.subject.abbreviation }})
                    </th>
                    <td v-if="examData.grades">{{ getStudentScore(getStudentSubjectMark(examSubject.subject.id), true)}}</td>
                    <td class="px-1">
                      <span :class="getStudentSubjectMark(examSubject.subject.id) ? getStudentSubjectMark(examSubject.subject.id).is_failed ? 'text-danger' : 'text-dark' : ''">
                        {{ getStudentScore(getStudentSubjectMark(examSubject.subject.id)) }}
                        <!-- {{ examData.grades ? getStudentSubjectMark(examSubject.subject.id).exam_mark_grade : getStudentSubjectMark(examSubject.subject.id).exam_mark_score }} -->
                      </span>
                    </td>
                    <td class="px-1">{{ examSubject.pass_mark }}</td>
                    <td class="px-1">{{ examSubject.full_mark }}</td>
                  </tr>
                </tbody>
              </table>
            </vue-custom-scrollbar>
          </div>
        </div>

        <!-- Reports -->
        <div class="d-flex flex-wrap p-2 bg-light" v-if="reportsData">
          <div class="col-12 col-md-4 mb-2 mb-md-0">
            <p class="mb-0">
              Score:
              <span class="ml-2 font-weight-bold">{{reportsData.total_marks_scored}} / {{reportsData.total_full_mark}}</span>
            </p>
          </div>
          <div class="col-12 col-md-4 mb-2 mb-md-0">
            <p class="mb-0">
              Percentage:
              <span class="ml-2 font-weight-bold">{{reportsData.percentage_score}}%</span>
            </p>
          </div>
          <div class="col-12 col-md-4 mb-2 mb-md-0">
            <p class="mb-0">
              Attendance:
              <span class="ml-2 font-weight-bold">{{reportsData.total_present_days}} / {{reportsData.total_working_days}}</span>
            </p>
          </div>
        </div>

        <!-- Remarks -->
        <div class="row mt-3">
          <div class="col-12">
            <student-exam-remarks :student="studentData" :examData="examData" :remarksData="remarksData" @updateTable="handleRemarkTableUpdate"/>
          </div>
        </div>
      </a-spin>
      <div class="position-absolute neo-tr-5 d-print-none">
        <button
          type="button"
          class="btn btn-light btn-sm btn-with-addon"
          @click="print"
        >
          <span class="btn-addon">
            <i class="btn-addon-icon fe fe-printer" />
          </span>
          Print
        </button>
      </div>
    </neo-print-wrapper>
  </div>
</template>

<script>
import { find } from 'lodash'

import vueCustomScrollbar from 'vue-custom-scrollbar'
import NeoPrintWrapper from '@/components/layout/Print/Default'

import StudentExamRemarks from '../Remark/index'

export default {
  name: 'StudentMarksDisplaySingle',
  props: ['studentData', 'examData', 'reportsData', 'remarksData'],
  components: {
    vueCustomScrollbar,
    StudentExamRemarks,
    NeoPrintWrapper,
  },
  data: function() {
    return {
      loading: false,
    }
  },
  computed: {
    classStudent: function() {
      return this.studentData.student
    },
    studentMarks: function() {
      return this.studentData.student_exam_mark
    },
  },
  methods: {
    getStudentSubjectMark(subjectId) {
      return find(this.studentMarks, { subject_id: subjectId })
    },
    getStudentScore(markData, getScore) {
      if (!getScore && markData) {
        if (this.examData.grades) {
          return markData.exam_mark_grade
        } else {
          if (markData.is_absent) {
            return '-'
          }
          return markData.mark
        }
      }

      if (getScore) {
        if (markData.is_absent) {
          return '-'
        }
        return markData.exam_mark_score
      }
      if (!markData) return '-'
    },
    handleRemarkTableUpdate() {
      this.$emit('updateRemarksTable')
    },
    print() {
      this.$htmlToPaper('examResultSingle')
    },
  },
}
</script>
